var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bl" }, [
    _c(
      "div",
      { staticClass: "text-center superCenter" },
      [_c("v-progress-circular", { attrs: { indeterminate: "", size: "32" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }